// ParentEdit.js
import React from 'react';
import {
  Edit,
  SimpleForm,
  TextInput,
  ReferenceManyField,
  Datagrid,
  TextField,
  ReferenceField,
  // useNotify,
  useRecordContext,
  Button,
} from 'react-admin';
import CopyToClipboard from 'react-copy-to-clipboard';
// import { Button } from '@mui/material';
import { Box } from '@mui/system';
// import { supabaseClient } from './supabase';
// import {
//   FunctionsHttpError,
//   FunctionsRelayError,
//   FunctionsFetchError,
// } from '@supabase/supabase-js';
import { ResetAuthUserButton } from './ResetAuthUserButton';

const CopyHashButton = () => {
  const [copied, setCopied] = React.useState(false);
  const record = useRecordContext();

  const handleCopy = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <CopyToClipboard text={record.household_hash} onCopy={handleCopy}>
      <Button variant="contained" color="primary">
        {copied ? 'Copied!' : 'Copy'}
      </Button>
    </CopyToClipboard>
  );
};

// const ResetAuthUserButton = () => {
//   const record = useRecordContext();
//   const notify = useNotify();
//   const handleResetUser = async () => {
//     const { error: resetUserError } = await supabaseClient.functions.invoke(
//       'resetAuthUser',
//       {
//         body: {
//           id: record.authid,
//           email: record.email,
//         },
//       }
//     );
//     if (resetUserError instanceof FunctionsHttpError) {
//       const errorMessage = await resetUserError.context.json();
//       console.log(`resetAuthUser return an error: ${errorMessage}`);
//       notify(`Error resetting user: ${resetUserError}`, { type: 'error' });
//       return false;
//     } else if (resetUserError instanceof FunctionsRelayError) {
//       console.log(`Relay error: ${resetUserError.message}`);
//       notify(`resetAuthUser relay error: ${resetUserError.message}`, {
//         type: 'error',
//       });
//     } else if (resetUserError instanceof FunctionsFetchError) {
//       console.log(`Fetch error: ${resetUserError.message}`);
//       notify(`resetAuthUser fetch error: ${resetUserError.message}`, {
//         type: 'error',
//       });
//     }
//     console.log(`Successfully reset user: ${record.email}`);
//     notify(`Successfully reset user: ${record.email}`, { type: 'success' });
//   };
//   return (
//     <Button
//       sx={{
//         padding: '12px 24px',
//         color: '#D9D9D9',
//         fontWeight: 'bold',
//         fontSize: '12pt',
//         backgroundColor: '#ab261d',
//         '&:hover': {
//           backgroundColor: '#d63024',
//         },
//       }}
//       onClick={handleResetUser}
//     >
//       {record.invited_at ? 'Reset User' : 'Invite User'}
//     </Button>
//   );
// };

const ParentEdit = (props) => {
  return (
    <Edit 
      {...props} 
      title="Edit parent"
      transform={data => { 
        delete data.last_sign_in_at; 
        delete data.invited_at;
        return data;
      }}
    >
      <SimpleForm>
        <TextInput disabled source="id" style={{ display: 'none' }} />
        <TextInput source="first_name" />
        <TextInput source="last_name" />
        <TextInput source="email" />
        <TextInput source="mobile" />
        <Box
          sx={{
            // border: '1px solid red',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <TextInput source="household_hash" disabled style={{ width: 400 }} />
          <CopyHashButton />
        </Box>
        <TextInput
          source="invited_at"
          defaultValue="NEVER INVITED"
          disabled
          style={{ width: 400 }}
        />
        <TextInput
          source="last_sign_in_at"
          defaultValue="NEVER SIGNED IN"
          disabled
          style={{ width: 400 }}
        />
        <ResetAuthUserButton />
      </SimpleForm>
      <Box
        sx={{
          color: 'text.primary',
          fontSize: 32,
          fontWeight: 'medium',
          paddingLeft: '15px',
        }}
      >
        Children
      </Box>
      <ReferenceManyField
        label="Children"
        reference="students"
        target="household_hash"
        source="household_hash"
      >
        <Datagrid bulkActionButtons={false}>
          <TextField source="last_name" />
          <TextField source="first_name" />
          <ReferenceField source="class_id" reference="classes">
            <TextField source="class_code" />
          </ReferenceField>
          <TextField source="household_hash" />
        </Datagrid>
      </ReferenceManyField>
    </Edit>
  );
};

export default ParentEdit;
